export const COMPANY_CONTAINER = 936;
export const INPUT_BOX_HEIGHT = 36;
